module.exports = __webpack_public_path__ + "media/images/awave_consulting_logo-aa409f82a693c76def496fb9c9e584a8.jpeg";